'use client';

import config from './global';
import ApiPaths from './paths';

interface RequestBody {
  [key: string]: any;
}

interface RequestParams {
  [key: string]: any;
}
const Api = {
  checkLogin: () => {
    return config.axiosHandle().get(`${config.apiFolder}/auth/check-login`);
  },
  sendCode: (body: RequestBody) => {
    return config.axiosHandle().post(`${config.apiFolder}${ApiPaths.sendCodePath}`, body);
  },
  Login: (body: RequestBody) => {
    return config.axiosHandle().post(`${config.apiFolder}${ApiPaths.confirmCode}`, body);
  },
  signup: (body: RequestBody) => {
    return config.axiosHandle().post(`${config.apiFolder}${ApiPaths.signupPath}`, body);
  },
  uploadFile: (body: RequestBody, myconfig = {}, query = '') => {
    return config
      .axiosHandle()
      .post(`/${config.apiFolder}/system/upload` + query, body, { ...myconfig });
  },

  searchAll: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}/system/search-global`, params);
  },

  categoryList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.categoryPath, params);
  },
  productList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.productsPath, params);
  },
  orderList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.orderPath, params);
  },
  favShopList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.favShops, params);
  },
  wishlist: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.wishlistPath, params);
  },
  removeWishlist: (id?: number | string) => {
    return config.axiosHandle().delete(`${config.apiFolder}` + `/wishlist/${id}`);
  },
  addWishlist: (body: RequestParams = {}) => {
    return config.axiosHandle().post(`${config.apiFolder}` + ApiPaths.wishlistPath, body);
  },
  // =========== address
  addressList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.addressesPath, params);
  },
  editAddress: (id: number | string, body: RequestBody) => {
    return config
      .axiosHandle()
      .put(`${config.apiFolder}` + ApiPaths.addressesPath + `/${id}`, body);
  },
  addAddress: (body: RequestBody) => {
    return config.axiosHandle().post(`${config.apiFolder}` + ApiPaths.addressesPath, body);
  },
  deleteAddress: (id?: number | string, body: RequestBody = {}) => {
    return config.axiosHandle().delete(`${config.apiFolder}${ApiPaths.addressesPath}/${id}`, body);
  },
  // ============= cart
  cartList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.cartPath, params);
  },
  addEditCart: (body: RequestBody = {}, headers: any = {}) => {
    return config.axiosHandle(headers).post(`${config.apiFolder}` + ApiPaths.cartPath, body);
  },
  deleteCartItem: (productId?: number | string, body: RequestBody = {}) => {
    return config
      .axiosHandle()
      .delete(`${config.apiFolder}${ApiPaths.cartPath}/${productId}`, body);
  },
  deleteCart: (params: RequestParams = {}) => {
    return config.axiosHandle().delete(`${config.apiFolder}` + ApiPaths.cartPath, params);
  },
  // ============= shop
  shopList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.shopPath, params);
  },
  shopFollow: (id?: number | string) => {
    return config.axiosHandle().post(`${config.apiFolder}` + `/shop/${id}/follow`);
  },
  shopUnFollow: (id?: number | string) => {
    return config.axiosHandle().delete(`${config.apiFolder}` + `/shop/${id}/follow`);
  },
  userUpdate: (body: RequestBody) => {
    return config.axiosHandle().put(`${config.apiFolder}` + ApiPaths.userInfoUpdatePath, body);
  },
  userInfo: (body: RequestBody) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.userInfoPath, body);
  },
  cityList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.cityPath, params);
  },
  provinceList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.provincePath, params);
  },
  countryList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.countryPath, params);
  },
  blogList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.blogPath, params);
  },
  // ===========
  attributeList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.attributePath, params);
  },
  reviewProduct: (id?: number | string, params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + `/product/${id}/reviews`, params);
  },
  submitProductReview: (id?: number | string, body: RequestParams = {}) => {
    return config.axiosHandle().post(`${config.apiFolder}` + `/product/${id}/reviews`, body);
  },
  editProductReview: (
    id?: number | string,
    reviewId?: number | string,
    body: RequestParams = {},
  ) => {
    return config
      .axiosHandle()
      .put(`${config.apiFolder}` + `/product/${id}/reviews/${reviewId}`, body);
  },
  priceRange: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.priceRange, params);
  },
  addView: (id?: number | string, body: RequestParams = {}) => {
    return config.axiosHandle().post(`${config.apiFolder}` + `/product/${id}/view`, body);
  },
  placeOrder: (body: RequestParams = {}) => {
    return config.axiosHandle().post(`${config.apiFolder}` + ApiPaths.orderPath, body);
  },
  couponValidate: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.couponPath, params);
  },
  orderSummary: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.cartSummary, params);
  },

  brandList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.brandList, params);
  },
  brandCountries: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.brandCountries, params);
  },
  modelList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.modelList, params);
  },
  colorList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.colorList, params);
  },
  tagList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.tagList, params);
  },
  blogCategoryList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.blogCategoryList, params);
  },
  // =============
  commentList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.commentList, params);
  },
  commentInsert: (body: RequestParams = {}) => {
    return config.axiosHandle().post(`${config.apiFolder}` + ApiPaths.commentList, body);
  },
  commentUpdate: (body: RequestParams = {}) => {
    return config.axiosHandle().put(`${config.apiFolder}` + ApiPaths.commentList, body);
  },
  commentDelete: (id?: number | string | null) => {
    return config.axiosHandle().delete(`${config.apiFolder}` + `${ApiPaths.commentList}/${id}`);
  },
  // ==============
  usersPlateList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.platesList, params);
  },
  plateUpdate: (body: RequestParams = {}) => {
    return config.axiosHandle().put(`${config.apiFolder}` + `${ApiPaths.platesList}`, body);
  },
  getnearby: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.nearbyShops, params);
  },
  // =================

  usersAddressList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.userAddressList, params);
  },
  userAddressInsert: (body: RequestParams = {}) => {
    return config.axiosHandle().post(`${config.apiFolder}` + ApiPaths.userAddressList, body);
  },
  userAddressUpdate: (body: RequestParams = {}) => {
    return config.axiosHandle().put(`${config.apiFolder}` + ApiPaths.userAddressList, body);
  },
  userAddressDelete: (id: number, body: RequestParams = {}) => {
    return config
      .axiosHandle()
      .delete(`${config.apiFolder}` + `${ApiPaths.userAddressList}/${id}`, body);
  },
  // ===================
  serviceList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.servicePath, params);
  },

  // ======== each shop service
  shopServicesLists: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.shopServices, params);
  },
  // ================= subuser
  addSubUserLevel1: (body: RequestParams = {}) => {
    return config.axiosHandle().post(`${config.apiFolder}` + ApiPaths.subUserLevel1, body);
  },
  addSubUserLevel2: (body: RequestParams = {}) => {
    return config.axiosHandle().post(`${config.apiFolder}` + ApiPaths.subUserLevel2, body);
  },
  // ================
  serviceHistory: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.serviceHistory, params);
  },

  // ===========
  serviceInquery: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.serviceInquery, params);
  },
  serviceSubCategoryList: (params: RequestParams = {}) => {
    return config
      .axiosHandle()
      .get(`${config.apiFolder}` + ApiPaths.serviceSubCategoryPath, params);
  },
  setDefault: (params: RequestParams = {}) => {
    return config.axiosHandle().put(`${config.apiFolder}` + ApiPaths.setDefaultPath, params);
  },
  getDefault: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.getDefaultPath, params);
  },
  // ==========
  getWallet: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.getWallet, params);
  },
  // ==========
  subUserList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.subuserListPath, params);
  },
  syncSubuser: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.subuserSync, params);
  },
  removeSubuser: (id?: number | string) => {
    return config.axiosHandle().delete(`${config.apiFolder}` + `${ApiPaths.removeSubUser}/${id}`);
  },
  payment: (body: RequestParams = {}) => {
    return config.axiosHandle().post(`${config.apiFolder}` + ApiPaths.paymentPath, body);
  },
  transactionList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.transactionList, params);
  },
  transactionListBank: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.transactionListBank, params);
  },
  transactionExcel: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.transactionListExcel, params);
  },
  transactionExcelBank: (params: RequestParams = {}) => {
    return config
      .axiosHandle()
      .get(`${config.apiFolder}` + ApiPaths.transactionListExcelBank, params);
  },
  transactionSum: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.transactionSum, params);
  },
  myPlatesListHistory: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.myplatesList, params);
  },
  getMyplatesHistoryItems: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.myplatesHistoryItems, params);
  },
  allPlatesInq: (body: RequestParams = {}) => {
    return config.axiosHandle().post(`${config.apiFolder}` + ApiPaths.allPlatesInq, body);
  },
  deleteAccount: () => {
    return config.axiosHandle().delete(`${config.apiFolder}` + ApiPaths.deleteAccountPath);
  },
  paymentInitiate: (body: RequestBody = {}) => {
    return config.axiosHandle().post(`${config.apiFolder}` + '/payment/initiate', body);
  },
  fetchNoAuth: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.fetchNoAuth, params);
  },
  // ------------- dashboard
  userProductList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.userProductList, params);
  },
  userProductDelete: (id?: number | string) => {
    return config.axiosHandle().delete(`${config.apiFolder}` + `${ApiPaths.userProductList}/${id}`);
  },
  productCategoryList: (params: RequestParams = {}) => {
    return config.axiosHandle().get(`${config.apiFolder}` + ApiPaths.productCategoryPath, params);
  },
};
export default Api;
